import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue';
import apiService from '@/services/ApiService';
import notificationService from '@/services/NotificationService';
import { User } from '@/models/User';
import UserProfilePhoto from '@/components/layout/shared/ProfilePhoto/UserProfilePhoto.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRecoveryDialog',
  emits: ["started"],
  setup(__props, { expose, emit }: { emit: ({ (e: 'started'): void }), expose: any, slots: any, attrs: any }) {



const showDialog = ref(false);
const submitting = ref(false);
const attempted = ref(false);
const member = ref<User | null>(null);
const roleLabel = ref('');
const form = reactive({ newEmail: '', reason: '', identityVerified: false });

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const emailValid = computed(() => EMAIL_PATTERN.test(form.newEmail.trim()));
const reasonValid = computed(() => form.reason.trim().length > 0 && form.reason.trim().length <= 500);
const canSubmit = computed(() => emailValid.value && reasonValid.value && form.identityVerified);
const newEmailInvalid = computed(() => attempted.value && !emailValid.value);
const reasonInvalid = computed(() => attempted.value && !reasonValid.value);
const memberName = computed(() => (member.value ? `${member.value.firstName} ${member.value.lastName}`.trim() : ''));

const show = (target: User, role = '') => {
  member.value = target;
  roleLabel.value = role;
  Object.assign(form, { newEmail: '', reason: '', identityVerified: false });
  attempted.value = false;
  showDialog.value = true;
};

const close = () => {
  showDialog.value = false;
};

const handleSubmit = async () => {
  attempted.value = true;
  if (!canSubmit.value || !member.value) return;

  submitting.value = true;
  try {
    const res = await apiService.company.startAccountRecovery(member.value.id, {
      newEmail: form.newEmail.trim(),
      reason: form.reason.trim(),
      identityVerified: form.identityVerified,
    });
    notificationService.success(res.data.message);
    showDialog.value = false;
    emit('started');
  } catch (err) {
    apiService.handleResponseError(err);
  } finally {
    submitting.value = false;
  }
};

expose({ show });

return { __sfc: true,emit, showDialog, submitting, attempted, member, roleLabel, form, EMAIL_PATTERN, emailValid, reasonValid, canSubmit, newEmailInvalid, reasonInvalid, memberName, show, close, handleSubmit, UserProfilePhoto }
}

})